// React
import axios from "axios";
import React, { useState, useEffect } from "react";

// Ionic
import {
  IonContent,
  IonIcon,
  IonPage,
  IonGrid,
  IonReorder,
  IonButton,
  useIonAlert,
  IonReorderGroup,
  IonItemDivider,
  IonList,
  IonInput,
  IonRow,
  IonCol,
  IonItem,
  IonLabel,
} from "@ionic/react";

//Data
import UserService from "../Context/user.service";

//Icons
import {
  chevronDownOutline,
  chevronUpOutline,
  trashOutline,
  compassOutline,
  createOutline,
  checkmarkOutline,
  closeOutline,
  addCircleOutline,
} from "ionicons/icons";
import userService from "../Context/user.service";

// Packages

function Bookmarks(props) {
  if (typeof window.parent.seturl !== "undefined") {
    window.parent.seturl("bookmarks");
  }

  var userInitial = 0;
  var logedInInitial = false;
  var isProinitial = false;
  var tokenInitial = "";

  const tokenData = UserService.getUserData();
  if (typeof tokenData["tokenData"].MerchantCustomerId !== "undefined") {
    userInitial = tokenData["tokenData"].MerchantCustomerId;
    logedInInitial = true;

    if (tokenData.login == 1) {
      logedInInitial = true;
    }
    if (tokenData.pro == 1) {
      isProinitial = true;
    }
    tokenInitial = tokenData.cookie;
  }

  const [isLoaded, setIsLoaded] = useState(false);
  const [isPro, setIsPro] = useState(isProinitial);
  const [isLoggedIn, setIsLoggedIn] = useState(logedInInitial);
  const [user, setUser] = useState(userInitial);
  const [token, setToken] = useState(tokenInitial);
  const [minimalData, setMinimalData] = useState([]);

  const [presentAlert] = useIonAlert();
  const [bookmarks, setBookmarks] = useState([]);
  const [newItem, setNewItem] = useState(false);

  useEffect(() => {
    if (isPro) {
      UserService.getBookmarks(user, token).then(
        (response) => {
          UserService.getMinimalData().then(
            (minData) => {
              setMinimalData(minData.data);
              setBookmarks(response.data);
              setIsLoaded(true);
            },
            (error) => {
              console.log(error);
            }
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } else {
      setIsLoaded(true);
    }
  }, []);

  function openGoogleMapsLink(data) {
    var maplink = "/";

    data.forEach((element) => {
      if (element.toString().indexOf("Eigenes Ziel: ") !== -1) {
        var cleandata = element.toString().replace("Eigenes Ziel: ", "");
      } else {
        var mindata = minimalData.data[element];
        var cleandata = mindata.lat + "," + mindata.lng;
      }

      maplink += cleandata + "/";
    });
    window.open("https://www.google.com/maps/dir" + maplink, "_blank");
    //window.location.href = 'https://www.google.com/maps/dir'+maplink;
  }

  function removeItem(itemId, listname) {
    UserService.getBookmarks(user, token).then(
      (response) => {
        const newList = bookmarks;

        for (var i = 0; i < newList.lists.length; i++) {
          if (newList.lists[i].name == listname) {
            newList.lists[i].items.splice(
              newList.lists[i].items.indexOf(itemId),
              1
            );
          }
        }

        setBookmarks(newList);
        setIsLoaded(false);
        setIsLoaded(true);
        saveList();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function removeList(listId) {
    document.querySelector("[data-id='" + listId + "']").remove();

    var cilditems = document.querySelectorAll(
      "[data-subitem-from='" + listId + "']"
    );
    if (
      typeof cilditems !== "undefined" &&
      cilditems !== null &&
      cilditems.length > 0
    ) {
      cilditems.forEach((el) => {
        el.remove();
      });
    }
    saveList(true, true);
  }

  function handleReorder(event) {
    var childs = document.getElementById("SortList").childNodes;
    var datasubitemfrom = "Standardliste";
    childs.forEach((child) => {
      if (child.tagName == "ION-ITEM-DIVIDER") {
        datasubitemfrom = child.id;
      }
      if (child.tagName == "ION-ITEM") {
        child.setAttribute("data-subitem-from", datasubitemfrom);
      }
    });
    event.detail.complete();
    setTimeout(function () {
      saveList(true);
    }, 500);
  }

  function toggleList(listId) {
    if (
      document
        .querySelector("[data-id='" + listId + "']")
        .getAttribute("togglestate") == "close"
    ) {
      document
        .querySelectorAll(
          "[data-subitem-from='" + listId + "'][data-type='pitch-item']"
        )
        .forEach((el) => {
          el.style.display = "block";
          document
            .querySelector("[data-id='" + listId + "']")
            .setAttribute("togglestate", "open");
        });
      document
        .querySelectorAll("ion-button[data-subitem-from='" + listId + "']")
        .forEach((el) => {
          el.style.display = "inline-block";
          document
            .querySelector("[data-id='" + listId + "']")
            .setAttribute("togglestate", "open");
        });
      document
        .querySelectorAll("ion-input[data-subitem-from='" + listId + "']")
        .forEach((el) => {
          el.style.display = "inline-block";
          document
            .querySelector("[data-id='" + listId + "']")
            .setAttribute("togglestate", "open");
        });
      document.querySelector(
        "[data-id='" + listId + "'] .icon__up"
      ).style.display = "inline-block";
      document.querySelector(
        "[data-id='" + listId + "'] .icon__down "
      ).style.display = "none";
    } else {
      document
        .querySelectorAll("[data-subitem-from='" + listId + "']")
        .forEach((el) => {
          el.style.display = "none";
          document
            .querySelector("[data-id='" + listId + "']")
            .setAttribute("togglestate", "close");
        });
      document.querySelector(
        "[data-id='" + listId + "'] .icon__up"
      ).style.display = "none";
      document.querySelector(
        "[data-id='" + listId + "'] .icon__down "
      ).style.display = "inline-block";
    }
  }

  function toggleListStandard(listId) {
    if (
      document
        .querySelector("[id='" + listId + "']")
        .getAttribute("togglestate") == "close"
    ) {
      document
        .querySelectorAll(
          "[data-subitem-from='" + listId + "'][data-type='pitch-item']"
        )
        .forEach((el) => {
          el.style.display = "block";
          document
            .querySelector("[id='" + listId + "']")
            .setAttribute("togglestate", "open");
        });
      document
        .querySelectorAll("ion-button[data-subitem-from='" + listId + "']")
        .forEach((el) => {
          el.style.display = "inline-block";
          document
            .querySelector("[id='" + listId + "']")
            .setAttribute("togglestate", "open");
        });
      document
        .querySelectorAll("ion-input[data-in-list='" + listId + "']")
        .forEach((el) => {
          el.style.display = "inline-block";
          document
            .querySelector("[id='" + listId + "']")
            .setAttribute("togglestate", "open");
        });
      document.querySelector(".icon__up__standard").style.display =
        "inline-block";
      document.querySelector(".icon__down__standard").style.display = "none";
    } else {
      document
        .querySelectorAll("[data-subitem-from='" + listId + "']")
        .forEach((el) => {
          el.style.display = "none";
          document
            .querySelector("[id='" + listId + "']")
            .setAttribute("togglestate", "close");
        });
      document
        .querySelectorAll("ion-input[data-in-list='" + listId + "']")
        .forEach((el) => {
          el.style.display = "none";
          document
            .querySelector("[id='" + listId + "']")
            .setAttribute("togglestate", "close");
        });
      document.querySelector(".icon__up__standard").style.display = "none";
      document.querySelector(".icon__down__standard").style.display =
        "inline-block";
    }
  }

  async function saveList(without, reload) {
    // make shure that all subitems belong to the right list
    var savedata = {
      pid: bookmarks.pid,
      lists: [{ name: "Standardliste", items: [] }],
    };

    var childs = document.getElementById("SortList").childNodes;
    var datasubitemfrom = "Standardliste";
    var i = 0;
    childs.forEach((child) => {
      if (child.tagName == "ION-ITEM-DIVIDER") {
        datasubitemfrom = child.id;
        i++;
        savedata.lists[i] = {
          name: child.querySelector(".listValue b").innerHTML,
          items: [],
        };
      }
      if (child.tagName == "ION-ITEM") {
        savedata.lists[i].items.push(child.id);
      }
    });

    var savedataParm =
      JSON.stringify(savedata) + "&pid=" + bookmarks.pid + "&token=" + token;

    try {
      const response = await axios
        .post(userService.saveBookmarksURL + "&savedataParm=" + savedataParm, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          },
        })
        .then(function (response) {
          if (typeof reload !== "undefined") {
            window.location.reload();
          }
        });
    } catch (err) {
      console.log(err);
    }

    if (typeof without === "undefined") {
      setBookmarks(savedata);
      setIsLoaded(false);
      setIsLoaded(true);
    }
    setNewItem(false);
  }

  function editList(listId) {
    document.querySelector(
      "[data-id='" + listId + "'] .listValue"
    ).style.display = "none";
    document.querySelector(
      "[data-id='" + listId + "'] .listInput"
    ).style.display = "block";
  }

  function addList() {
    UserService.getBookmarks(user, token).then(
      (response) => {
        const newList = bookmarks;

        newList.lists.splice(1, 0, {
          name: checkBookmarklistName("Neue Liste"),
          items: [],
        });

        setBookmarks(newList);
        setIsLoaded(false);
        setIsLoaded(true);
        saveList();

        setTimeout(function () {
          document
            .getElementById("SortList")
            .scrollIntoView({ behavior: "smooth" });
        }, 800);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function viewList(listId, save) {
    document.querySelector(
      "[data-id='" + listId + "'] .listValue"
    ).style.display = "block";
    document.querySelector(
      "[data-id='" + listId + "'] .listInput"
    ).style.display = "none";

    if (save === true) {
      document.querySelector(
        "[data-id='" + listId + "'] .listValue"
      ).innerHTML =
        "<b>" +
        document.querySelector(
          "[data-id='" + listId + "'] .listInput ion-input"
        ).value +
        "</b>";
      saveList();
    }
  }

  function addCustomTarget(list) {
    var listinput = document.querySelector(
      "[data-in-list='" + list + "']"
    ).value;
    if (listinput === "") {
      return false;
    }

    UserService.getBookmarks(user, token).then(
      (response) => {
        const newList = bookmarks;
        /* for (var i = 0; i < newList.lists.length; i++) {
          if (newList.lists[i].name === list) {
            newList.lists[i].items.push(listinput);
          }
        } */
        for (var i = 0; i < newList.lists.length; i++) {
          if (newList.lists[i].name === list) {
            newList.lists[i].items.push(listinput);

            let listlength = newList.lists[i].items.length - 1;
            newList.lists[i].items[listlength] = "Eigenes Ziel: " + listinput;
          }
        }

        setBookmarks(newList);
        setIsLoaded(false);
        setIsLoaded(true);
        saveList();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  function checkBookmarklistName(name) {
    bookmarks.lists.forEach((list) => {
      if (list.name === name) {
        name = name + "(1)";
        return name;
      }
    });
    return name;
  }

  function isNumeric(str) {
    return !isNaN(str) && !isNaN(parseFloat(str));
  }


  return isLoaded ? (
    <IonPage>
      <IonContent className="ion-padding" fullscreen>
        <IonGrid>
          <IonCol>
            {(function () {
              if (isLoggedIn && isPro) {
                return (
                  <>
                    <IonRow size="12">
                      <h2>Merkliste</h2>
                    </IonRow>
                    <IonRow size="12">
                      <a
                        onClick={() => addList()}
                        id="newlistn"
                        class="newbookmarklist__button"
                      >
                        Neue Merkliste erstellen
                        <IonIcon icon={addCircleOutline}></IonIcon>
                      </a>
                      {/*                      <IonButton
                          id="newlist"
                          className="newbookmarklist__button"
                          onClick={() => addList()}
                          shape="round"
                          slot="end"
                      >
                        Neue Merkliste erstellen
                        <IonIcon icon={addCircleOutline}></IonIcon>
                      </IonButton>*/}
                    </IonRow>
                    <IonRow size="12">
                      <IonList className="bookmark_list">
                        <IonItemDivider
                          data-type="list-item"
                          id="Standardliste"
                          className="listitem__heading"
                        >
                          <div className="list__divider__wrapper">
                            <div className="listvalue__wrapper">
                              <IonLabel>
                                <h6>
                                  <b>Standardliste</b>
                                </h6>
                              </IonLabel>
                            </div>

                            <div className="listbutton_wrapper">
                              <IonButton
                                className="listbutton"
                                color="primary"
                                shape="round"
                                data-subitem-from="Standardliste"
                                onClick={(e) =>
                                  (window.location.href =
                                    "/map/route/Standardliste")
                                }
                              >
                                Route anzeigen{" "}
                              </IonButton>
                              <IonButton
                                className="listbutton"
                                color="primary"
                                shape="round"
                                data-subitem-from={bookmarks.lists[0].name}
                                onClick={(e) =>
                                  openGoogleMapsLink(bookmarks.lists[0].items)
                                }
                              >
                                Route an Navi übertragen{" "}
                                <IonIcon
                                  icon={compassOutline}
                                  className="iconbutton__trash"
                                />
                              </IonButton>
                            </div>
                            <div className="customitem__wrapper">
                              <IonInput
                                data-in-list="Standardliste"
                                placeholder="Eigenes Ziel hinzufügen"
                                className="customitem__input"
                                onKeyPress={(e) => {
                                  if (e.key === "Enter") {
                                    addCustomTarget("Standardliste");
                                  }
                                }}
                              ></IonInput>

                              <IonButton
                                onClick={(e) =>
                                  addCustomTarget("Standardliste")
                                }
                                className="listbutton"
                                color="dark"
                                shape="round"
                                data-subitem-from="Standardliste"
                              >
                                <IonIcon icon={addCircleOutline} />
                              </IonButton>
                            </div>

                            <IonButton
                              onClick={() =>
                                toggleListStandard("Standardliste")
                              }
                              className="icon__toggle"
                              fill="clear"
                              size="small"
                            >
                              <IonIcon
                                icon={chevronDownOutline}
                                color="secondary"
                                className="icon__down__standard"
                              />
                              <IonIcon
                                icon={chevronUpOutline}
                                color="secondary"
                                className="icon__up__standard"
                              />
                            </IonButton>
                          </div>
                        </IonItemDivider>

                        <IonReorderGroup
                          disabled={false}
                          onIonItemReorder={handleReorder}
                          id="SortList"
                        >
                          {bookmarks.lists.map((item) => {
                            return (
                              <>
                                {/*only show if not Standardliste to prevent sort before it*/}
                                {item.name !== "Standardliste" && (
                                  <IonItemDivider
                                    key="{item.name}"
                                    data-type="list-item"
                                    data-id={item.name}
                                    className="listitem__heading"
                                  >
                                    <div className="list__divider__wrapper">
                                      <div className="listvalue__wrapper">
                                        <IonLabel>
                                          <h6 className="listValue">
                                            <b>{item.name}</b>
                                          </h6>
                                          <h6
                                            className="listInput"
                                            style={{ display: "none" }}
                                          >
                                            <b>
                                              <IonInput
                                                value={item.name}
                                                className="list__input"
                                              ></IonInput>
                                              <IonButton
                                                size="small"
                                                shape="round"
                                                className="button__input"
                                                onClick={() =>
                                                  viewList(item.name, true)
                                                }
                                              >
                                                <IonIcon
                                                  icon={checkmarkOutline}
                                                  color="white"
                                                />
                                              </IonButton>

                                              <IonButton
                                                size="small"
                                                shape="round"
                                                className="button__input"
                                                onClick={() =>
                                                  viewList(item.name, false)
                                                }
                                              >
                                                <IonIcon
                                                  icon={closeOutline}
                                                  color="white"
                                                />
                                              </IonButton>
                                            </b>
                                          </h6>
                                        </IonLabel>

                                        <IonButton
                                          onClick={() => editList(item.name)}
                                          rel="noreferrer"
                                          fill="clear"
                                        >
                                          <IonIcon
                                            icon={createOutline}
                                            color="medium"
                                            className="icon__create"
                                          />
                                        </IonButton>
                                      </div>

                                      <div className="listbutton_wrapper">
                                        <IonButton
                                          className="listbutton"
                                          color="primary"
                                          shape="round"
                                          data-subitem-from={item.name}
                                          onClick={(e) =>
                                            (window.location.href = `/map/route/${item.name}`)
                                          }
                                        >
                                          Route anzeigen{" "}
                                        </IonButton>
                                        <IonButton
                                          className="listbutton"
                                          color="primary"
                                          shape="round"
                                          data-subitem-from={item.name}
                                          onClick={(e) =>
                                            openGoogleMapsLink(item.items)
                                          }
                                        >
                                          Route an Navi übertragen{" "}
                                          <IonIcon
                                            icon={compassOutline}
                                            className="iconbutton__trash"
                                          />
                                        </IonButton>
                                        <IonButton
                                          className="listbutton_delete"
                                          color="secondary"
                                          shape="round"
                                          data-subitem-from={item.name}
                                          onClick={() =>
                                            presentAlert({
                                              header:
                                                "Liste wirklich endgültig löschen? ",
                                              buttons: [
                                                {
                                                  text: "Nein",
                                                  role: "cancel",
                                                  handler: () => {
                                                    return false;
                                                  },
                                                },
                                                {
                                                  text: "Ja",
                                                  role: "confirm",
                                                  handler: () => {
                                                    removeList(item.name);
                                                  },
                                                },
                                              ],
                                            })
                                          }
                                        >
                                          Liste löschen{" "}
                                          <IonIcon
                                            icon={trashOutline}
                                            className="iconbutton__trash"
                                          />
                                        </IonButton>
                                      </div>
                                      <div className="customitem__wrapper">
                                        <IonInput
                                          data-in-list={item.name}
                                          data-subitem-from={item.name}
                                          placeholder="Eigenes Ziel hinzufügen"
                                          className="customitem__input"
                                          onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                              addCustomTarget(item.name);
                                            }
                                          }}
                                        ></IonInput>

                                        <IonButton
                                          onClick={(e) =>
                                            addCustomTarget(item.name)
                                          }
                                          className="listbutton"
                                          color="dark"
                                          shape="round"
                                          data-subitem-from={item.name}
                                        >
                                          <IonIcon
                                            icon={addCircleOutline}
                                            className="iconbutton__add"
                                          />
                                        </IonButton>
                                      </div>
                                      <IonButton
                                        onClick={() => toggleList(item.name)}
                                        className="icon__toggle"
                                        fill="clear"
                                      >
                                        <IonIcon
                                          icon={chevronDownOutline}
                                          color="secondary"
                                          className="icon__down"
                                        />
                                        <IonIcon
                                          icon={chevronUpOutline}
                                          color="secondary"
                                          className="icon__up"
                                        />
                                      </IonButton>
                                    </div>
                                  </IonItemDivider>
                                )}
                                {item.items.map((bm) => {
                                  if (!isNumeric(bm)) {
                                    return (
                                      <>
                                        <IonItem
                                          key={bm}
                                          data-subitem-from={item.name}
                                          data-type="pitch-item"
                                          id={bm}
                                          data-id={bm}
                                        >
                                          <p className="itemValue">{bm}</p>
                                          <a
                                            href={`https://www.google.de/maps/search/${bm.replace(
                                              "Eigenes Ziel: ",
                                              ""
                                            )}`}
                                            className="icon__navigation"
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            <IonIcon
                                              icon={compassOutline}
                                              color="medium"
                                            />
                                          </a>
                                          <IonButton
                                            onClick={() =>
                                              removeItem(bm, item.name)
                                            }
                                            rel="noreferrer"
                                            className="icon__trash"
                                            fill="clear"
                                          >
                                            <IonIcon
                                              icon={trashOutline}
                                              color="secondary"
                                            />
                                          </IonButton>

                                          <IonReorder slot="start"></IonReorder>
                                        </IonItem>
                                      </>
                                    );
                                  } else {
                                    return (
                                      <>
                                        <IonItem
                                          key={bm}
                                          data-subitem-from={item.name}
                                          data-type="pitch-item"
                                          id={bm}
                                        >
                                          <a href={`/map/pitch/${bm}`}>
                                            <p className="itemValue">

                                              {typeof minimalData.data[bm] !==
                                                "undefined" &&
                                                (
                                                  <>
                                                    {minimalData.data[bm].country}-{minimalData.data[bm].zip} {minimalData.data[bm].city}, <strong>{minimalData.data[bm].title}</strong> 
                                                  </>
                                                )
                                              }
                                              
                                            </p>
                                          </a>
                                          <a
                                            href={`https://www.google.de/maps/search/${minimalData.data[bm].title}`}
                                            className="icon__navigation"
                                            target="_blank"
                                          >
                                            <IonIcon
                                              icon={compassOutline}
                                              color="medium"
                                            />
                                          </a>
                                          <IonButton
                                            onClick={() =>
                                              removeItem(bm, item.name)
                                            }
                                            rel="noreferrer"
                                            className="icon__trash"
                                            fill="clear"
                                          >
                                            <IonIcon
                                              icon={trashOutline}
                                              color="secondary"
                                            />
                                          </IonButton>

                                          <IonReorder slot="start"></IonReorder>
                                        </IonItem>
                                      </>
                                    );
                                  }
                                })}
                              </>
                            );
                          })}
                        </IonReorderGroup>
                        {/*
                        <IonButton
                            id="newlist"
                            className="newbookmarklist__button"
                            onClick={() => addList()}
                            shape="round"
                            slot="end"
                        >
                          Neue Merkliste erstellen
                          <IonIcon icon={addCircleOutline}></IonIcon>
                        </IonButton>*/}
                      </IonList>
                    </IonRow>{" "}
                  </>
                );
              } else {
                if (typeof window.parent.setPaywallModal !== "undefined") {
                  window.parent.setPaywallModal("pro");
                }

                return (
                  <>
                    <IonRow size="12" className="ion-justify-content-center">
                      <h2>Merkliste</h2>
                    </IonRow>
                    <IonRow size="12" className="ion-justify-content-center">
                      <p>
                        {" "}
                        Bitte loggen Sie sich ein um diese Funktion zu nutzen.
                      </p>
                    </IonRow>
                  </>
                );
              }
            })()}
          </IonCol>
        </IonGrid>
      </IonContent>
    </IonPage>
  ) : (
    <></>
  );
}

export default Bookmarks;
